// extracted by mini-css-extract-plugin
module.exports = {"PMCard":"PMCard_PMCard__1Orj3"};